var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDecommissionedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.795,
    height: 21.795,
    viewBox: "0 0 21.795 21.795",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "block_FILL1_wght700_GRAD0_opsz48",
    d: "M13.635,24.495A10.567,10.567,0,0,1,9.4,23.637a11.065,11.065,0,0,1-3.47-2.343A10.888,10.888,0,0,1,3.6,17.823a10.77,10.77,0,0,1-.845-4.264,10.5,10.5,0,0,1,.858-4.213A10.909,10.909,0,0,1,9.4,3.558a10.9,10.9,0,0,1,8.477,0,11.019,11.019,0,0,1,3.457,2.331,11.2,11.2,0,0,1,2.343,3.457,10.371,10.371,0,0,1,.871,4.213,10.631,10.631,0,0,1-.858,4.264,11,11,0,0,1-5.814,5.814A10.567,10.567,0,0,1,13.635,24.495Zm0-2.407A8.155,8.155,0,0,0,19.64,19.6a8.249,8.249,0,0,0,2.471-6.044,8.449,8.449,0,0,0-.435-2.689A7.837,7.837,0,0,0,20.4,8.488L8.538,20.32a6.352,6.352,0,0,0,2.356,1.345A9.007,9.007,0,0,0,13.635,22.087ZM6.9,18.656,18.706,6.823a8.017,8.017,0,0,0-2.382-1.268,8.525,8.525,0,0,0-2.689-.423A8.219,8.219,0,0,0,7.629,7.579a8.092,8.092,0,0,0-2.471,5.98,7.9,7.9,0,0,0,.474,2.715A9.36,9.36,0,0,0,6.9,18.656Z",
    transform: "translate(-2.75 -2.7)",
    fill: "#d52d34"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecommissionedIcon);
export default __webpack_public_path__ + "static/media/DecommissionedIcon.c30b3675b52be132a5f98ca4167a1105.svg";
export { ForwardRef as ReactComponent };